export const TP_WR_SECONDS = 220;